import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

type Props = {
  caseCard: GatsbyTypes.ContentfulCase;
};

export const IndexCaseCard: React.FC<Props> = ({ caseCard }) => {
  return (
    <>
      <article className="caseCard">
        <Link to={`/cases/${caseCard.contentful_id}`}>
          {caseCard?.ogpImage?.gatsbyImageData && (
            <div className="thumb">
              {/* 流れるスライドでは画面外の画像が読み込まれずグレーのまま残るため、すぐ読み込む */}
              <GatsbyImage image={caseCard.ogpImage.gatsbyImageData} alt="" loading="eager" />
            </div>
          )}
          <div className="body">
            {caseCard.company?.name && <h3 className="company">{caseCard.company.name}</h3>}
            <p className="title">{caseCard.title}</p>
          </div>
        </Link>
      </article>

      <style jsx>{`
        .caseCard {
          height: 100%;
          width: 100%;
        }
        .caseCard :global(a) {
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow: hidden;
          border: 1px solid rgba(62, 56, 52, 0.08);
          border-radius: 18px;
          background-color: ${colors.white};
          box-shadow: 0 1px 2px rgba(62, 56, 52, 0.04), 0 12px 28px rgba(62, 56, 52, 0.06);
          color: ${colors.defaultText};
          text-decoration: none;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
        }
        .caseCard :global(a:hover) {
          transform: translateY(-6px);
          border-color: rgba(255, 100, 0, 0.22);
          box-shadow: 0 2px 4px rgba(62, 56, 52, 0.04), 0 20px 40px rgba(255, 100, 0, 0.14);
        }

        /* ---------- サムネイル ---------- */
        .thumb {
          position: relative;
          overflow: hidden;
          aspect-ratio: 1.618;
          width: 100%;
          background: ${colors.gray3};
        }
        .thumb :global(.gatsby-image-wrapper) {
          height: 100%;
          width: 100%;
        }
        .thumb :global(img) {
          transition: transform 0.5s ease;
        }
        .caseCard :global(a:hover img) {
          transform: scale(1.06);
        }

        /* ---------- 本文 ---------- */
        .body {
          display: flex;
          flex: 1;
          flex-direction: column;
          padding: 20px 22px 22px;
        }
        .company {
          margin: 0;
          color: ${colors.defaultText};
          font-size: 16.5px;
          font-weight: bold;
          line-height: 1.5;
          letter-spacing: 0.01em;
        }
        .title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          margin: 8px 0 0;
          color: ${colors.lightText};
          font-size: 15px;
          font-weight: normal;
          line-height: 1.7;
        }

        @media (${breakPoints.sp}) {
          .caseCard :global(a:hover) {
            transform: none;
            border-color: rgba(62, 56, 52, 0.08);
            box-shadow: 0 1px 2px rgba(62, 56, 52, 0.04), 0 12px 28px rgba(62, 56, 52, 0.06);
          }
          .caseCard :global(a:hover img) {
            transform: none;
          }
          .body {
            padding: 16px 18px 18px;
          }
          .company {
            font-size: 15px;
          }
          .title {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};
